const Orders= [
    'Ordered', 'Process', 'Shipped', 'Delivered', 'Canceled' 
]
const types = [
    { label: 'House', en: 'house', ar: 'المنزل', value: 'house' },
    { label: 'Building', en: 'building', ar: 'المبني', value: 'building' },
    { label: 'Office', en: 'office', ar: 'المكتب', value: 'office' },
]
export { Orders, types }